import axios from '@/utils/axios'

export function buildFetcher<T>(url) {
  return () => axios.get<T>(url).then(res => res.data)
}
